import type { IAdvisoryInput } from './IAdvisoryInput';
import type { IAdvisoryRecommendation } from './IAdvisoryRecommendation';
import type { IChecklistItem } from './IChecklistItem';

/**
 * Рекомендовані дії (прототип v4, advRecs): немає відповідального · прострочено · немає терміну · немає доручень · ні з чим не
 * зв'язано · немає файлів · усі доручення виконано. Правила для полів, яких тип не має, пропускаються. Чиста функція.
 */
export function advisoryRecommendations(s: IAdvisoryInput): IAdvisoryRecommendation[] {
  const out: IAdvisoryRecommendation[] = [];
  if (s.hasAssigneeField && !s.assigned) out.push({ key: 'noOwner', tone: '#c2410c', action: 'assignMe' });
  if (s.hasDueField && !s.done && s.due && s.due.slice(0, 10) < s.today) out.push({ key: 'overdue', tone: '#b91c1c', action: 'openHistory', date: s.due });
  if (s.hasDueField && !s.done && !s.due) out.push({ key: 'noDue', tone: '#b7791f' });
  if (!s.done && !s.assignments) out.push({ key: 'noAssignments', tone: '#6b3fd1', action: 'addAssignment' });
  if (!s.links) out.push({ key: 'notLinked', tone: '#1f4ebc', action: 'linkItem' });
  if (!s.files && !s.done) out.push({ key: 'noFiles', tone: '#0e7490', action: 'goFiles' });
  if (!s.done && s.assignments > 0 && s.assignmentsDone === s.assignments) out.push({ key: 'allDone', tone: '#1f8a5b', action: 'markDone' });
  return out;
}

/** Стан елемента за кількістю рекомендацій: 0 — у нормі, менше 3 — потребує уваги, інакше — під ризиком. Чиста функція. */
export function advisoryHealth(count: number): 'healthy' | 'attention' | 'risk' {
  return count === 0 ? 'healthy' : count < 3 ? 'attention' : 'risk';
}

/**
 * Контрольний список (прототип v4, CHECK): 7 пунктів позначаються з даних запису («авто»), «перевірено перед закриттям» і «сторони
 * поінформовано» — лише вручну; ручна позначка зберігається в записі (ext.checklist). Чиста функція.
 */
export function checklistItems(s: IAdvisoryInput, manual: Record<string, boolean>): IChecklistItem[] {
  const auto: Array<[string, boolean]> = [
    ['scope', s.described], ['owner', s.assigned], ['deadline', Boolean(s.due)], ['team', s.assignments > 0], ['context', s.links > 0],
    ['docs', s.files > 0], ['discussed', s.comments > 0], ['review', false], ['informed', false],
  ];
  return auto.map(([key, a]) => ({ key, on: a || Boolean(manual[key]), auto: a && !manual[key] }));
}
